import './common'
import '../scss/style.scss';

import '~components/input/input'
import '~components/slider/slider'
import '~components/popup/popup'
import '~components/filter/filter'
import '~components/gallery/gallery'
import '~components/rating-bar/rating-bar'
import '~components/questions/questions'
import '~components/carousel/carousel'
import '~components/dropdown/dropdown'
import '~components/accordion/accordion'
import '~components/card/card'

import './filter'
import './paginator'
